import React, { useContext, useEffect, useState } from "react"
import { QRCodeSVG } from "qrcode.react"
import toastError from "../../errors/toastError"

import { Dialog, DialogContent, Paper, Typography } from "@mui/material"
import { i18n } from "../../translate/i18n"
import api from "../../services/api"

import { SocketContext } from "../../context/Socket/SocketContext"

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
    const [qrCode, setQrCode] = useState("")

    const { socket } = useContext(SocketContext)

    useEffect(() => {
        const fetchSession = async () => {
            if (!whatsAppId) return

            try {
                const { data } = await api.get(`/whatsapp/${whatsAppId}`)
                setQrCode(data.qrcode)
            } catch (err) {
                toastError(err)
            }
        }
        fetchSession()
    }, [whatsAppId])

    useEffect(() => {
        if (!whatsAppId) return
        const companyId = localStorage.getItem("companyId")

        socket.on(`company-${companyId}-whatsappSession`, (data) => {
            if (data.action === "update" && data.session.id === whatsAppId) {
                setQrCode(data.session.qrcode)
            }

            if (data.action === "update" && data.session.qrcode === "") {
                onClose()
            }
        })
    }, [whatsAppId, onClose, socket])

    return (
        <Dialog open={open} onClose={onClose} maxWidth="lg" scroll="paper">
            <DialogContent sx={{ backgroundColor: "white" }}>
                <Paper elevation={0} sx={{ backgroundColor: "white" }}>
                    <Typography sx={{ color: "#000000" }} gutterBottom>
                        {i18n.t("qrCode.message")}
                    </Typography>
                    {qrCode ? (
                        <QRCodeSVG value={qrCode} size={256} />
                    ) : (
                        <Typography sx={{ color: "#000000" }}>
                            Waiting for QR Code
                        </Typography>
                    )}
                </Paper>
            </DialogContent>
        </Dialog>
    )
}

export default React.memo(QrcodeModal)
